import { sha256 } from "js-sha256";

export function getAvatarImage(address: string) {
  const cleanAddress = address.trim().toLowerCase();
  const hashString = sha256(cleanAddress);

  return `https://gravatar.com/avatar/${hashString}?d=mp`;
}
